import { PieChartToolbarSlotProps } from '../../types/toolbar.js';

export const Toolbar = (props: PieChartToolbarSlotProps) => null;

Toolbar['displayName'] = 'PieChart.Toolbar';
